module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/5-51e67e72f80d451c4c5403dcc834a094.webm";